import { Component, OnInit, OnDestroy } from '@angular/core';
import { Objective, Project, Icons, User, UserType } from 'toolbandi-ui-lib';
import { SharedDataService, CrudService, MessageService, Breadcrumb } from 'elbuild-ui-lib-core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-objective-edit',
	templateUrl: './objective-edit.component.html',
	styleUrls: ['./objective-edit.component.scss']
})
export class ObjectiveEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	objective: Objective;
	project: Project;

	error: boolean;
	breadcrumb: any;
	usercompanyid: number;

	constructor(
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private objectiveService: CrudService<Objective>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private projectService: CrudService<Project>,
		private router: Router
	) { }

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const oid = +params['oid'];
			const pid = +params['pid'];
			if (oid) {
				this.load(oid);
			} else {
				this.objective = new Objective();
				if (pid) {
					this.objective.projectid = pid;
					this.findProject(this.objective.projectid);
				}

				this.loading = false;
			}
		});

		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {
				const user: User = data as User;
				this.usercompanyid = (user.utype === UserType.company) ? user.companyid : undefined;
			}
		});
	}

	load(id: number): void {
		this.loading = true;
		this.objectiveService.getEntity(Objective, 'objective', id).subscribe(obj => {
			this.objective = obj;
			this.loading = false;
			if (this.objective) {
				this.error = false;
				this.initItem();
			} else {
				this.error = true;
			}
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.objective'));
			this.objective = undefined;
			this.loading = false;
			this.error = true;
		});

	}



	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.companies', url: '/company' },
			{ title: this.project.company.name, url: '/company/view/' + this.project.company.id, icon: Icons.COMPANY, icontooltip: 'labels.company' },
			{ title: 'labels.view-project', url: '/company/project/view/' + this.project.id, fragment: 'obiettivi', param: this.project.name, icon: Icons.PROJECT, icontooltip: 'labels.project' }
		];


		this.breadcrumb.title = { title: 'labels.objective-edit', param: this.objective.name, icon: Icons.OBJECTIVE, icontooltip: 'labels.objective' };
	}



	findProject(pid: number): void {
		if (pid) {
			this.projectService.getEntity(Project, 'project', pid).subscribe((p: Project) => {
				this.project = p;
				this.setBreadcrumb();
			});
		}
	}

	initItem(): void {
		this.findProject(this.objective.projectid);
	}

	setSelectedFields(): void {
		this.objective.projectid = this.project.id;
	}

	submit(): void {
		this.setSelectedFields();


		if (this.objective.stopdate < this.objective.startdate) {
			this.messageService.sendError(
				this.translateService.instant('errors.objective-1'));
			return;
		}

		/* const interval = this.objective.stopdateasdate.getTime() - this.objective.startdateasdate.getTime();
		const days = interval / 1000 / 60 / 60 / 24;
		if (days < this.objective.dayofwork) {
			this.messageService.sendError(
				this.translateService.instant('errors.objective-2'));
			return;
		} */

		if (this.objective.startdate < this.project.startdate || this.objective.startdate > this.project.stopdate
			|| this.objective.stopdate < this.project.startdate || this.objective.stopdate > this.project.stopdate) {
			this.messageService.sendError(
				this.translateService.instant('errors.objective-3'));
			return;
		}



		if (!this.objective.id) {
			this.objectiveService.createEntity(Objective, 'objective', this.objective).subscribe(response => {
				this.objective = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.objective-save-success'),
					this.translateService.instant('labels.success')
				);


				this.router.navigate(['/company/project/view/', this.project.id], { fragment: 'obiettivi' });

			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.objectiveService.saveEntity(Objective, 'objective', this.objective).subscribe(response => {
				this.objective = response;
				this.initItem();
				this.messageService.sendSuccess(
					this.translateService.instant('labels.objective-save-success'),
					this.translateService.instant('labels.success')
				);
				this.router.navigate(['/company/project/view/', this.project.id], { fragment: 'obiettivi' });

			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}



}
